import * as rules from "LIB/validation/rules";
import { ATTACHMENT_TYPE } from "APP_ROOT/constants";

export default function validateAttachment(attachment) {
  attachment.validate(ATTACHMENT_TYPE).satisfies(rules.required);
  attachment.validate("file").satisfies(rules.requiredUnlessUploaded);
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/components/shared/FormSections/validate.js